<template>
    <a class="button-back" @click="back" v-show="backBtn">
      <img src="media/global/btn_back.png"/>
      <div class="button-title">{{items.globalButtons.backButton}}</div>
    </a>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    computed: {
      location () {
        return this.$store.state.scormLMS.location
      },
      items() {
        return this.$store.state.items
      },
      backBtn() {
        return this.$store.state.backBtn
      }
    },
    methods: {
      back() {
        this.$store.commit('scormLMS/locationMinus');
      }
    },
    components: {},
    props: []
  }

</script>

<style scoped>
.button-back {
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 990;
  cursor: pointer;
  user-select: none;
  -webkit-filter: drop-shadow(1.5px 1.5px 1px #222 );
  filter: drop-shadow(1.5px 1.5px 1px #222);
}
.button-back.disabled {
  display: none;
  pointer-events: none;
  cursor: default;
}
.button-title {
  font-family: 'Nunito';
  position: absolute;
  bottom: 3px;
  left: 42px;
  z-index: 999;
  font-size: 13px;
  text-decoration: none;
  color: black;
}

@media only screen and (max-width: 750px) {
  .button-back {
    bottom: 5px;
    left: 5px;
  }
  .button-title {

  }
}

</style>



// WEBPACK FOOTER //
// ButtonBack.vue?63f65c98